import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const salesRepsAdapter = getAdapter({ idFieldName: 'id' });

const salesRepsSlice = createSlice({
  name: 'salesReps',
  initialState: salesRepsAdapter.getInitialState(),
  reducers: {
    setSalesReps: (state, { payload: { salesReps } }) => {
      salesRepsAdapter.setAll(state, salesReps);
    }
  }
});

const selectors = salesRepsAdapter.getSelectors(({ salesReps }) => salesReps);

export const getSalesReps = state => selectors.selectAll(state);

export const { setSalesReps } = salesRepsSlice.actions;

export default salesRepsSlice.reducer;
